module.exports = __webpack_public_path__ + "mybanker-case-bg.632f8c8604709525eade.png";